import { Component, Vue } from '@natureos/vue-facing-decorator';

import Toasts from '@/common/components/ui/toast/toast.component.vue';
import { wait } from './common/helpers';

@Component({ components: { Toasts } })
export default class extends Vue {
  private build: string | null = null;

  private created(): void {
    console.log('MODE', import.meta.env.MODE);
    console.log('STAGE', import.meta.env.VITE_STAGE);
    console.log('ZONES', import.meta.env.VITE_ZONES_API);
    if (import.meta.env.MODE === 'development') {
      return;
    }

    this.initVersionCheck();
  }

  private beforeUnmount(): void {
    if (import.meta.env.MODE === 'development') {
      return;
    }

    document.removeEventListener('visibilitychange', this.checkVersion);
  }

  private async initVersionCheck(): Promise<void> {
    try {
      const res = await fetch(`/version.json?v=${new Date().getTime()}`);

      if (res.ok) {
        const data = await res.json();

        this.build = data.build as string;

        if (!this.build) {
          return;
        }

        document.addEventListener('visibilitychange', this.checkVersion);
      }
    } catch (error) {
      // Offline / flaky-network blips are expected for a background
      // poller — warn keeps them out of Sentry (captureConsole: errors only).
      console.warn('Error fetching version.json:', error);
    }
  }

  private async checkVersion(): Promise<void> {
    if (document.hidden || !this.build) {
      return;
    }

    try {
      const res = await fetch(`/version.json?v=${new Date().getTime()}`);

      if (res.ok) {
        const data = await res.json();
        console.log('this.build', this.build);
        console.log('data.build', data.build);

        if (data && (data.build as string) !== this.build) {
          document.removeEventListener('visibilitychange', this.checkVersion);

          this.$toast.info(
            this.$t('A new platform update is available. The page will reload to apply the latest version.'),
            6000,
          );

          await wait(5000);

          window.location.reload();
        }
      }
    } catch (error) {
      // Offline / flaky-network blips are expected for a background
      // poller — warn keeps them out of Sentry (captureConsole: errors only).
      console.warn('Error fetching version.json:', error);
    }
  }
}
